export default __webpack_public_path__ + "a2b3f31a3c7fbf0213a6959edfdb1abe.png";